import axios, { type AxiosInstance, type AxiosError } from 'axios'
import type { ApiError } from '@/types/api'

const baseURL = import.meta.env.VITE_API_URL ?? '/api/v1'

/**
 * Shared axios instance for the FastAid OS API.
 * Sends cookies (JWT httpOnly) with every request and normalizes errors.
 */
export const httpService: AxiosInstance = axios.create({
  baseURL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'x-requested-with': 'XMLHttpRequest',
    'x-app-source': 'website',
  },
})

httpService.interceptors.response.use(
  (response) => response,
  (error: AxiosError<{ message?: string | string[]; error?: string }>) => {
    const status = error.response?.status ?? 0
    const raw = error.response?.data?.message ?? error.response?.data?.error ?? error.message
    const message = Array.isArray(raw) ? raw.join(', ') : (raw ?? 'Something went wrong. Please try again.')

    const normalized: ApiError = {
      status,
      message,
      details: error.response?.data,
    }
    return Promise.reject(normalized)
  },
)
